import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import apiCall from "../../../components/Api";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import BackBtn from "../../../components/Common/backBtn";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import SucessModal from "../../../components/Modal/SucessModal";
import { MoleculeBreadcrumbsList } from "../Const";

const SaltMoleculesForm = ({ edit = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}salt-molecule/get/${id}`)
      .then((response) => {
        setValue("molecule_name", response.data.molecule_name);
        setValue(
          "therapeutic_classification",
          response.data.therapeutic_classification,
        );
        setValue("active", response.data.active);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const onSubmit = async (fields) => {
    if (edit) {
      const result = await apiCall(
        `salt-molecule/update/${id}`,
        "PATCH",
        fields,
      );
      if (result.data?._id) {
        setSuccess(true);
      }
    } else {
      const result = await apiCall(`salt-molecule/create`, "POST", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Healthsy Services",
        link: "/healthsy-services/order-medicines/medicine-details",
      },
      {
        text: "Order Medicines",
        link: "/healthsy-services/order-medicines/medicine-details",
      },
      {
        text: "Master",
        link: "/healthsy-services/order-medicines/masters/manufacturer",
      },
      {
        text: "Salt-Molecule",
        link: "/healthsy-services/order-medicines/masters/salt-molecules",
      },
      { text: edit ? "Edit Salt/Moleucle" : "Add Salt/Moleucle", link: "" },
    ],
    [],
  );

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="healthsyMasterBreadCrumbs"
                breadcrumbsList={MoleculeBreadcrumbsList("", edit)}
              />
              <BackBtn navigatePath="/healthsy-services/order-medicines/masters/salt-molecules" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Moleucle Name"
                  errorText="Please enter the Moleucle Name"
                  name="molecule_name"
                  placeholder="Type here..."
                />
              </div>
              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Therapeutic Classification"
                  errorText="Please enter the Therapeutic Classification"
                  name="therapeutic_classification"
                  placeholder="Type here..."
                />
              </div>
            </div>
            <div className="row car-dep-form">
              <div className="col-3">
                <InputRadioField
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  labelName="Status"
                />
              </div>
            </div>
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </MainconternLayout>

      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/healthsy-services/order-medicines/masters/salt-molecules"}
          name="new Moleucles"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default SaltMoleculesForm;
